import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {dashboardPwa_template} from "../components/templates/dashboardPwa_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

let chartDiv;

export class dashboard_pwa extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected dashboardPwa_Template: dashboardPwa_template;
    protected viewPageUrl;
    protected destroyed: boolean = false;

    protected getModuleName(){

        return "dashboard_pwa";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.dashboardPwa_Template = new dashboardPwa_template("list", this.viewModel, this);
        this.template = this.dashboardPwa_Template;
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;

        if(this.getVnAppZone().app.params.idBrand){
            (<header>loadedModule).setHeaderTitle("Live Dashboard");
        }else{
            (<header>loadedModule).setHeaderTitle("Network Live Dashboard");
        }

        return [this.dashboardPwa_Template.build()];
    } 

    public fillPage() : void{

        this.updateViewModelFromPath();
        this.getDataSubscriptions();
        this.getDataViews();
        this.getDataAccounts();
        this.getDataTrends();
        this.getDataSegments();
        this.dashboardPwa_Template.loadPage();
        this.loadingOut(this.dashboardPwa_Template.builtTemplate);
    }

    public autoRefresh() {
        if (this.destroyed) {
            return;
        }

        this.getDataSubscriptions();
        this.getDataViews();
        this.getDataAccounts();
        this.getDataTrends();
        this.getDataSegments();
    }

    public cleanup(): void {
        this.destroy();
    }

    protected destroy(): void {
        // Clean up resources
        chartDiv = null;
        this.viewPageUrl = null;
        this.dashboardPwa_Template = null;
        this.viewModel = null;
        this.destroyed = true;
    }

    protected getData(){

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/';
        if(this.getVnAppZone().app.params.idBrand){
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/';
        }
        let subViewModel = this.dashboardPwa_Template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataViews() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/views/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/views/';
        }
        let subViewModel = this.dashboardPwa_Template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataTrends() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/trends/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/trends/';
        }
        let subViewModel = this.dashboardPwa_Template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataSegments() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/segments/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/segments/';
        }
        let subViewModel = this.dashboardPwa_Template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected getDataSubscriptions() {
        chartDiv = document.getElementById("dashboard");
        let usrReq_url: string = '/api/dashboard/get/subscriptions/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/subscriptions/';
        }
        let subViewModel = this.dashboardPwa_Template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }
    
    protected getDataAccounts() {

        chartDiv = document.getElementById("dashboard");

        let usrReq_url: string = '/api/dashboard/get/accounts/';
        if (this.getVnAppZone().app.params.idBrand) {
            usrReq_url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/dashboard/get/accounts/';
        }
        let subViewModel = this.dashboardPwa_Template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetData, XMLHttpRequestHandler_requestType.GET, 'dashboard');
    }

    protected onGetData(req, obj) {
        return () => {
            obj.manageResponse(req, obj, () => {

                let responseParsed = JSON.parse(req.request.response, function (key, value) {
                    if (key == "date" || key == "publishDate" || key == "republishDate") {
                        return new Date(value);
                    } else {
                        return value;
                    }
                });
                obj.dashboardPwa_Template.setResults(responseParsed);
            });

            if (obj.getChartDiv()) {
                obj.loadingOut(obj.getChartDiv());
            } else {
                obj.loadingOut(obj.dashboardPwa_Template.builtTemplate);
            }
        }
    }

    public getChartDiv(){
        return chartDiv;
    }

    protected viewArticle(id, idBrand){

        if(this.getVnAppZone().app.params.idBrand){
            idBrand = this.getVnAppZone().app.params.idBrand;
        }
        this.viewPageUrl = '/brand/' + idBrand + '/analytics/live-dashboard' + id;
        window.open(this.viewPageUrl, "_blank");
    }

    public filterAutoRefreshStatusOnChange(){
        if (this.destroyed) {
            return;
        }
        
        this.getDataSubscriptions();
        this.getDataViews();
        this.getDataAccounts();
        this.getDataTrends();
        this.getDataSegments();
    }
}


// WEBPACK FOOTER //
// ./js/modules/dashboard_pwa.ts